module.exports = "<div class=\"notFound\">\n    <img src=\"./../../../assets/images/notfound.png\" alt=\"\">\n</div>"